var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-app"},[_c('SchedulerCalendar',{attrs:{"filter":_vm.filter,"active-tab":0,"is-home-view":true,"show-for-me-filter":true,"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }